var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-page"},[_c('h1',[_vm._v(_vm._s(_vm.$t('maintenance.page.text.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('maintenance.page.text.message')))]),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"javascript:location.reload()"}},[_vm._v(_vm._s(_vm.$t('maintenance.page.button.retry')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }